<router-outlet></router-outlet>
<footer style="text-align: center; padding: 20px; color: #888; font-size: 12px;">
  沪ICP备2025154192号
</footer>